export var Paths;
(function (Paths) {
    Paths["CMS"] = "cms";
    Paths["CRM"] = "crm2";
    Paths["SETTINGS"] = "settings";
})(Paths || (Paths = {}));
